module.exports = __webpack_public_path__ + "img/lang-zh.735c43ef.png";